import { MatPasswordStrengthComponent } from '@angular-material-extensions/password-strength';
import { Component, ViewChild, OnInit, Inject, OnDestroy, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';

@Component({
    selector: 'app-password-strength',
    imports: [MaterialModule, TranslateModule],
    templateUrl: './password-strength.component.html',
    styleUrl: './password-strength.component.scss'
})
export class PasswordStrengthComponent implements OnInit, OnDestroy {
  @ViewChild('passwordComponent', { static: true }) passwordComponent: MatPasswordStrengthComponent;
  @Input() passwordKey: string;
  subscription: Subscription;
  showDetails: boolean = false;

  constructor(@Inject(DynamicFormComponent) public form: DynamicFormComponent) { }

  ngOnInit() {
    this.subscription = this.form.formGroup.valueChanges.subscribe((values) => {
      this.showDetails = values[this.passwordKey]?.length > 0;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
